import { useState } from 'react';
import { SupportIcon } from '../assets/svgImages';

export default function ContactModal() {
  const [open, setOpen] = useState(false);

  const handleCall = () => {
    window.location.href = 'tel:1800123687';
  };

  const handleEmail = () => {
    window.location.href = '/contact-us';
  };

  return (
    <>
      {/* Icon/Button */}
      <div onClick={() => setOpen(true)}>
        <SupportIcon className="w-6 cursor-pointer mr-1" />
      </div>

      {/* Modal */}
      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="w-[80%] max-w-sm rounded-[32px] bg-white p-6">
            <button
              onClick={handleCall}
              className="mb-4 w-full rounded-full bg-primary-blue-500 py-4 text-md text-white"
            >
              Call 1800 123 687
            </button>

            <button
              onClick={handleEmail}
              className="mb-4 w-full rounded-full bg-primary-blue-500 py-4 text-md text-white"
            >
              Email Us
            </button>

            <button
              onClick={() => setOpen(false)}
              className="w-full rounded-full bg-gray-200 py-4 text-md"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </>
  );
}
